<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template
						template(v-if='settings.searchTopic')
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_searchTopic') }}: {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + settings.searchTopic) }}
								br
						template(v-if='settings.selectedTopics.length')
								| {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}:
								template(v-for='topic in settings.selectedTopics')
										span
												| {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + topic) }};
										br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfRequired') }}: {{ settings.numOfUnknowns }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.numOfExamples }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}: {{ settings.tableSize }} x {{ settings.tableSize }}
						br
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
